<div class="container">
  <div class="left-panel">
    <div class="heading-wrap">
      <h2 style="flex: 6">
        How we do it with
        <span
          class="highlight"
          [ngClass]="{
            greenColor: items[selectedIndex].color === 'green',
            blueColor: items[selectedIndex].color === 'blue',
            yellowColor: items[selectedIndex].color === 'yellow',
            redColor: items[selectedIndex].color === 'red'
          }"
          >Inforida</span
        >
        ecosystem<span
          class="highlight"
          [ngClass]="{
            greenColor: items[selectedIndex].color === 'green',
            blueColor: items[selectedIndex].color === 'blue',
            yellowColor: items[selectedIndex].color === 'yellow',
            redColor: items[selectedIndex].color === 'red'
          }"
          >?</span
        >
      </h2>
      <div class="number-container mobile-number" style="flex: 1">
        <div
          class="number"
          [@numberAnimation]="selectedIndex"
          [ngStyle]="getNumberStyle()"
        >
          {{ selectedIndex + 1 }}
        </div>
      </div>
    </div>
    <div class="icons-wrapper">
      <button
        *ngFor="let item of items; let i = index"
        class="icon-button"
        [class.active]="selectedIndex === i"
        [class]="item.color"
        (click)="selectItem(i)"
      >
        <mat-icon>{{ item.icon }}</mat-icon>
      </button>
    </div>
    <div class="number-container desktop-number">
      <div
        class="number"
        [@numberAnimation]="selectedIndex"
        [ngStyle]="getNumberStyle()"
      >
        {{ selectedIndex + 1 }}
      </div>
    </div>
    <div class="cards-wrapper">
      <div class="content-stack">
        <div
          *ngFor="let item of items; let i = index"
          class="content-card"
          [class.active]="selectedIndex === i"
          [style.transform]="getCardTransform(i)"
          [ngClass]="{
            greenBg: items[selectedIndex].color === 'green',
            blueBg: items[selectedIndex].color === 'blue',
            yellowBg: items[selectedIndex].color === 'yellow',
            redBg: items[selectedIndex].color === 'red'
          }"
        >
          <mat-icon [class.active]="selectedIndex === i" [class]="item.color">{{
            item.icon
          }}</mat-icon>
          <div class="card-text">
            <h3>{{ item.title }}</h3>
            <p>{{ item.description }}</p>
          </div>
        </div>
      </div>
    </div>
    <a
      href="#"
      class="learn-more"
      [ngClass]="{
        greenColor: items[selectedIndex].color === 'green',
        blueColor: items[selectedIndex].color === 'blue',
        yellowColor: items[selectedIndex].color === 'yellow',
        redColor: items[selectedIndex].color === 'red'
      }"
    >
      Learn how we can do it for you →
    </a>
  </div>

  <div class="right-panel">
    <div class="content-stack">
      <div
        *ngFor="let item of items; let i = index"
        class="content-card"
        [class.active]="selectedIndex === i"
        [style.transform]="getCardTransform(i)"
      >
        <mat-icon [class.active]="selectedIndex === i" [class]="item.color">{{
          item.icon
        }}</mat-icon>
        <div class="card-text">
          <h3>{{ item.title }}</h3>
          <p>{{ item.description }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
